var map = {
	"./images/authorized-app.svg": "6741",
	"./images/devices-sprite.svg": "2e80",
	"./images/empty-box.svg": "1824",
	"./images/horizontal-logo-white.svg": "fedd",
	"./images/horizontal-logo.svg": "9f86",
	"./images/logos/facebook.png": "04a3",
	"./images/logos/googleplus.png": "a805",
	"./images/logos/instagram.png": "3637",
	"./images/logos/microsoft.png": "30f8",
	"./images/logos/salesforce.png": "39b9",
	"./images/logos/twitter.png": "7411",
	"./images/logos/vk.png": "1de7",
	"./images/logos/wechat.png": "1cf3",
	"./images/logos/zendesk.png": "e76a",
	"./images/rock-bg.jpg": "f281",
	"./images/vertical-logo-white.svg": "b1f0",
	"./images/vertical-logo.svg": "4acf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";